<template>
  <div>
    <v-badge
      color="pink"
      :content="workExperiences.length"
      :value="workExperiences.length && registrationStep != 6"
    >
      Work Experiences
    </v-badge>
    <v-btn
      v-if="registrationStep == 6"
      text
      small
      color="success"
      class="ml-3"
      @click="open_dialog_work_experience()"
      ><v-icon small left>mdi-plus</v-icon>Add</v-btn
    >
    <RegistrationAddWorkExperienceDialog
      ref="registrationAddWorkExperienceDialog"
      v-model="dialogs"
      :work-experiences="workExperiences"
      @add-item-work-experience="add_item_work_experience()"
      @close-dialog-work-experience="close_dialog_work_experience()"
    />
  </div>
</template>

<script>
import RegistrationAddWorkExperienceDialog from "@/components/registration/dialog/RegistrationAddWorkExperienceDialog.vue";

export default {
  name: "RegistrationAddWorkExperience",
  components: {
    RegistrationAddWorkExperienceDialog,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    workExperiences: {
      type: Array,
      default: () => [],
    },
    registrationStep: {
      type: Number,
      default: 0,
    },
  },
  emits: [
    "open-dialog-work-experience",
    "add-item-work-experience",
    "close-dialog-work-experience",
    "dialogs",
  ],
  computed: {
    dialogs: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("dialogs", value);
      },
    },
  },
  methods: {
    open_dialog_work_experience() {
      this.$emit("open-dialog-work-experience");
    },
    add_item_work_experience() {
      this.$emit("add-item-work-experience");
    },
    close_dialog_work_experience() {
      this.$emit("close-dialog-work-experience");
    },
  },
};
</script>
